var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';
import cx from 'classnames';
import { useButtonGroup } from '../button-group/button-group-context';
import { shadow } from '../theme/shadow';
const inGroupMixin = css `
  @apply cursor-pointer border-none text-center rounded-sm appearance-none relative h-5 py-0 px-4;

  background-color: ${(props) => props.selected === props.itemKey ? 'var(--button-color)' : 'transparent'};
  box-shadow: ${(props) => props.selected === props.itemKey ? shadow.sm : undefined};

  &::before {
    @apply absolute m-auto right-0 bottom-0 top-0 w-px h-3;
    content: '';
    background-color: #e5e5e5;
  }

  &:last-child {
    &::before {
      @apply hidden;
    }
  }

  &:focus {
    @apply border-none outline-none;
  }

  &::before {
    @apply hidden;
  }
`;
const notInGroupMixin = css `
  box-shadow: ${shadow.sm};
`;
const focusMixin = css `
  background-color: ${() => 'var(--primary)'};
  color: ${() => 'var(--primary-text-color)'};
`;
const unFocusMixin = css `
  color: ${(props) => {
    var _a;
    return props.buttonTheme === 'primary'
        ? (_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.primaryTextColor
        : 'var(--button-text-color)';
}};
  background-color: ${(props) => { var _a; return props.buttonTheme === 'primary' ? (_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.primary : 'var(--button-color)'; }};
`;
const lgMixin = css `
  @apply py-1 px-4 h-7;
`;
const StyledButton = styled(animated.button) `
  @apply cursor-pointer border-none text-center rounded appearance-none py-1 px-4 h-5;

  ${unFocusMixin};
  ${(props) => (props.size === 'lg' ? lgMixin : undefined)};

  &:focus {
    @apply outline-none border-none;
    ${(props) => (props.isButtonGroup ? unFocusMixin : focusMixin)};
  }
  ${(props) => (props.isButtonGroup ? inGroupMixin : notInGroupMixin)}
`;
export const Button = (_a) => {
    var { onClick, size = 'lg', buttonTheme = 'system' } = _a, props = __rest(_a, ["onClick", "size", "buttonTheme"]);
    const { onSelected, isButtonGroup, selected, buttonTheme: buttonGroupButtonTheme, } = useButtonGroup();
    const controlledButtonTheme = buttonGroupButtonTheme || buttonTheme;
    const handleOnClick = useCallback((e) => {
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(props.itemKey);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [onClick, onSelected, props.itemKey]);
    return (React.createElement(StyledButton, Object.assign({ isButtonGroup: isButtonGroup, onClick: handleOnClick, size: size, "data-role": "button", className: cx('button', props.className), buttonTheme: controlledButtonTheme, selected: selected }, props), props.children));
};
